import * as React from "react";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 4;
export const CardComparisonNoFeeAddedBenefitsEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [noFeeAddedBenefitsIcon, noFeeAddedBenefitsOne, noFeeAddedBenefitsTwo, noFeeAddedBenefitsThree] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <div className="uitk-type-center xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkLayoutGrid>
        <UitkLayoutGridItem>
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div dangerouslySetInnerHTML={noFeeAddedBenefitsIcon} />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={300} weight="medium" align="left">
                  <div dangerouslySetInnerHTML={noFeeAddedBenefitsOne} />
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem className="all-t-padding-three">
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div dangerouslySetInnerHTML={noFeeAddedBenefitsIcon} />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={300} weight="medium" align="left">
                  <div dangerouslySetInnerHTML={noFeeAddedBenefitsTwo} />
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem className="all-t-padding-three all-b-padding-six">
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div dangerouslySetInnerHTML={noFeeAddedBenefitsIcon} />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={300} weight="medium" align="left">
                  <div dangerouslySetInnerHTML={noFeeAddedBenefitsThree} />
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </div>
  );
};

export default CardComparisonNoFeeAddedBenefitsEditorial;
